import { Box, Typography } from '@mui/material';
import { Fragment, ReactNode } from 'react';
import { ResourceInfoSkeleton } from './skeletons/ResourceInfoSkeleton';

export type ResourceInfoItem = { name: string; data: ReactNode };

type Props = {
  items: ResourceInfoItem[] | null;
  loading?: boolean;
};

export const ResourceSummaryInfo = ({ items, loading }: Props) => {
  if (loading) {
    return <ResourceInfoSkeleton />;
  }
  if (!items) {
    return null;
  }
  return (
    <Box sx={{ display: 'grid', gridTemplateRows: 'auto', gridTemplateColumns: 'max-content', rowGap: { xs: 1, md: 2 }, columnGap: 2 }}>
      {items.map((item, index) => (
        <Fragment key={item.name}>
          <Typography variant="body1" sx={{ fontWeight: 600, gridRow: `${index + 1}`, gridColumn: '1 / 1', whiteSpace: 'nowrap' }}>
            {`${item.name}:`}
          </Typography>
          <Typography sx={{ gridRow: `${index + 1}`, gridColumn: '2 / 2' }}>{item.data}</Typography>
        </Fragment>
      ))}
    </Box>
  );
};
